import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import ProductCommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import AuthContext from '@/product/context/auth/authContext'

const InitialFunction = (props) => {
    const authContext = useContext(AuthContext)
    const { user, logout } = authContext
    const location = useLocation()
    const history = useHistory()
    const { getAllCountries, getAllStates, getAllCities } =
        useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)
    const {
        getAllDynamicFields,
        getAllDynamicTables,
        getAllDynamicPagesFields,
    } = useContext(DynamicContext)

    useEffect(() => {
        if (props.global) {
            getGlobalVariable()
        }
        if (props.countries) {
            getAllCountries()
        }
        if (props.states) {
            getAllStates()
        }
        if (props.cities) {
            getAllCities()
        }

        if (props.dynamicFields && localStorage.token) {
            getAllDynamicFields({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {},
            })
        }

        if (props.dynamicTables && localStorage.token) {
            getAllDynamicTables({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'dt.show_order',
                table: 'dynamic_tables',
                filters: {},
            })
        }

        if (props.dynamicPagesFields && localStorage.token) {
            getAllDynamicPagesFields({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'dvpi.id',
                primaryTable: 'dynamic_view_page_info',
                filters: {},
            })
        }
    }, [])

    useEffect(() => {
        if (user?.emp_permissions) {
            const allowedPaths = user.emp_permissions.split(',')
            const currentPath = location.pathname

            const isPrivilegedUser =
                user?.emp_type === 'super_admin' || user?.emp_type === 'admin'

            allowedPaths.push(`/onboard_response`)
            allowedPaths.push(`/zb/zp/transfer`)
            if (allowedPaths.includes('/listing')) {
                const listingId =
                    location.pathname.split('/listing/new/')[1] ||
                    location.pathname.split('/listing/edit/')[1]
                if (listingId) {
                    allowedPaths.push(`/listing/new/${listingId}`)
                    allowedPaths.push(`/listing/edit/${listingId}`)
                }
            }

            if (allowedPaths.includes('/buyers')) {
                const buyerID =
                    location.pathname.split('/users/view/')[1] ||
                    location.pathname.split('/users/edit/')[1]
                if (buyerID) {
                    allowedPaths.push(`/users/view/${buyerID}`)
                    allowedPaths.push(`/users/edit/${buyerID}`)
                }
            }

            if (allowedPaths.includes('/invoice')) {
                const [invoiceID, buyerID] = (
                    location?.pathname?.split('/invoice/view/all/')[1] || ''
                )?.split('/')

                if (invoiceID && buyerID) {
                    allowedPaths.push(
                        `/invoice/view/all/${invoiceID}/${buyerID}`
                    )
                }
            }
            if (allowedPaths.includes('/invoice/paid')) {
                const [invoiceID, buyerID] = (
                    location?.pathname?.split('/invoice/view/paid/')[1] || ''
                )?.split('/')

                if (invoiceID && buyerID) {
                    allowedPaths.push(
                        `/invoice/view/paid/${invoiceID}/${buyerID}`
                    )
                }
            }
            if (allowedPaths.includes('/invoice/unpaid')) {
                const [invoiceID, buyerID] = (
                    location?.pathname?.split('/invoice/view/unpaid/')[1] || ''
                )?.split('/')

                if (invoiceID && buyerID) {
                    allowedPaths.push(
                        `/invoice/view/unpaid/${invoiceID}/${buyerID}`
                    )
                }
            }
            if (allowedPaths.includes('/invoice/cancel')) {
                const [invoiceID, buyerID] = (
                    location?.pathname?.split('/invoice/view/cancel/')[1] || ''
                )?.split('/')

                if (invoiceID && buyerID) {
                    allowedPaths.push(
                        `/invoice/view/cancel/${invoiceID}/${buyerID}`
                    )
                }
            }
            if (allowedPaths.includes('/seller_payout')) {
                const [invoiceID, buyerID] = (
                    location?.pathname?.split('/invoice/view/paid/')[1] || ''
                )?.split('/')

                if (invoiceID && buyerID) {
                    allowedPaths.push(
                        `/invoice/view/paid/${invoiceID}/${buyerID}`
                    )
                }
            }
            if (allowedPaths.includes('/org')) {
                const sellerID =
                    location.pathname.split('/seller/new/')[1] ||
                    location.pathname.split('/seller/edit/')[1]
                if (sellerID) {
                    allowedPaths.push(`/seller/new/${sellerID}`)
                    allowedPaths.push(`/seller/edit/${sellerID}`)
                }
            }

            if (allowedPaths.includes('/employees')) {
                const employeeID =
                    location.pathname.split('/employees/new/')[1] ||
                    location.pathname.split('/employees/edit/')[1]
                if (employeeID) {
                    allowedPaths.push(`/employees/new/${employeeID}`)
                    allowedPaths.push(`/employees/edit/${employeeID}`)
                }
            }

            if (allowedPaths.includes('/questions_answers')) {
                const [questionID, productID] = (
                    location?.pathname?.split('/questions_answers/')[1] || ''
                )?.split('/')
                if (questionID && productID) {
                    allowedPaths.push(
                        `/questions_answers/${questionID}/${productID}`
                    )
                }
            }

            const isPathAllowed = allowedPaths.includes(currentPath)
            if (
                user?.emp_type === 'seller' &&
                currentPath !== '/noAccess' &&
                currentPath.includes('/users/view')
            ) {
                history.push('/noAccess')
                return
            }

            if (
                !isPrivilegedUser &&
                !isPathAllowed &&
                currentPath !== '/noAccess'
            ) {
                history.push('/noAccess')
            }
        }
    }, [user?.emp_permissions, user?.emp_type, location, history])

    return null
}

export default InitialFunction
